import { render, staticRenderFns } from "./PhoneNumbers.vue?vue&type=template&id=2435663f&"
import script from "./PhoneNumbers.vue?vue&type=script&lang=js&"
export * from "./PhoneNumbers.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumbers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports